import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import classNames from 'classnames';
import React from 'react';

import * as constants from './constants';
import TaskStatusCardPortalLabel from './TaskStatusCardPortalLabel';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { formatMoment } from '../../utils/dateUtils';

const useStyles = makeStyles({
  taskContainer: { flex: 1 },
  taskLabel: {
    color: colors.neutral7,
    fontWeight: 600,
    fontSize: 16,
    display: 'block',
  },
  activeTaskLabel: {
    color: colors.black,
  },
  dateLabel: {
    color: colors.neutral7,
    display: 'block',
  },
  activeLabel: {
    color: colors.utilityPositive,
    fontWeight: 600,
    display: 'block',
    paddingLeft: '8px',
  },
  statusCheckIcon: {
    color: colors.utilityPositive,
    verticalAlign: 'middle',
  },
  portalTask: {
    color: colors.orange,
  },
});

const TaskStatusCardDescription = ({ status, label, date, isTaskPortal }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const formattedDate = formatMoment(date);

  return (
    <Grid container justify="space-between" alignItems="center">
      <Grid item ui-ta="TaskStatusDescription" className={classes.taskContainer}>
        {isTaskPortal && <TaskStatusCardPortalLabel />}
        <Typography
          className={classNames(classes.taskLabel, {
            [classes.activeTaskLabel]: status === constants.taskStatuses.ACTIVE,
          })}
          variant="caption"
        >
          {label}
        </Typography>
        {formattedDate && (
          <Typography className={classes.dateLabel} variant="caption">
            {formattedDate}
          </Typography>
        )}
      </Grid>
      {status === constants.taskStatuses.COMPLETED && (
        <Grid item>
          <StatusCheck className={classes.statusCheckIcon} />
        </Grid>
      )}
      {status === constants.taskStatuses.ACTIVE && (
        <Grid item>
          <Typography
            className={classNames(classes.activeLabel, isTaskPortal ? classes.portalTask : '')}
            variant="caption"
            align="right"
          >
            {translateString('Active')}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default TaskStatusCardDescription;
